import { render, staticRenderFns } from "./ConsignmentOrderDetails.vue?vue&type=template&id=73c0915b&scoped=true"
import script from "./ConsignmentOrderDetails.vue?vue&type=script&lang=js"
export * from "./ConsignmentOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./ConsignmentOrderDetails.vue?vue&type=style&index=0&id=73c0915b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c0915b",
  null
  
)

export default component.exports